@if ({}; as STATE) {
  <section class="advertiser-creation-dialog">
    <advertiser-creation-form [advertiser]="advertiser()" />
  </section>
}
